import { useMemo, useState } from "react";
import { CalendarClock } from "lucide-react";
import {
  defaultKickoffISO,
  statusFor,
  viralScheduleFor,
} from "@/lib/media/viralScheduler";

function toLocalInput(iso: string) {
  const d = new Date(iso);
  const off = d.getTimezoneOffset() * 60_000;
  return new Date(d.getTime() - off).toISOString().slice(0, 16);
}

export function ViralMomentSchedule() {
  const [kickoff, setKickoff] = useState<string>(defaultKickoffISO());
  const items = useMemo(() => viralScheduleFor(kickoff), [kickoff]);

  return (
    <section className="rounded-2xl border border-border/60 bg-background/60 p-3">
      <header className="flex items-center justify-between gap-2">
        <h3 className="flex items-center gap-1.5 text-sm font-black uppercase tracking-wider">
          <CalendarClock className="h-3.5 w-3.5 text-primary" /> Viral Moment Schedule
        </h3>
        <input
          type="datetime-local"
          value={toLocalInput(kickoff)}
          onChange={(e) => {
            const d = new Date(e.target.value);
            if (!Number.isNaN(d.getTime())) setKickoff(d.toISOString());
          }}
          className="rounded-md border border-border/60 bg-background px-2 py-1 text-[11px]"
        />
      </header>
      <ul className="mt-2 space-y-1.5">
        {items.map((m) => {
          const status = statusFor(m.startAt, m.endAt);
          const color =
            status === "live" ? "text-emerald-400 border-emerald-500/40 bg-emerald-500/10"
            : status === "upcoming" ? "text-foreground border-border/60 bg-background/70"
            : "text-muted-foreground border-border/40 bg-background/40";
          return (
            <li key={m.kind} className={`flex items-center justify-between gap-2 rounded-lg border px-2 py-1.5 ${color}`}>
              <div className="flex items-center gap-2">
                <span className="text-base">{m.emoji}</span>
                <div>
                  <div className="text-xs font-black">{m.label}</div>
                  <div className="text-[10px] opacity-70">{m.cta}</div>
                </div>
              </div>
              <div className="text-right text-[10px] font-bold uppercase tracking-wider">
                <div>{new Date(m.startAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })}</div>
                <div className="opacity-70">{status}</div>
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}